import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchData } from 'src/fetch/stepB';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { getMemberInfo } from 'src/utils/common';
import { myInfoDataStore } from 'src/store/myInfo';
import { salaryDataStore } from 'src/store/mySalaryInfo';
import { preworkDataStore } from 'src/store/preworkInfo';
import Template from './template';

interface Props {
  num: number;
}

const StepB: FC<Props> = ({ num }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingSate = loadingModalViewStore((state: any) => state.set);
  const salaryDataState = salaryDataStore((state: any) => state.bind);
  const myInfoDataState = myInfoDataStore((state: any) => state.bind);
  const preworkDataState = preworkDataStore((state: any) => state.bind);
  const bindPreworkParam = preworkDataStore((state: any) => state.param);

  const param = userInfoData;

  useEffect(() => {
    fetchData(
      param,
      errorModalState,
      salaryDataState,
      preworkDataState,
      myInfoDataState,
      loadingSate,
      queryClient
    );
  }, [bindPreworkParam]);

  return (
    <div className="_step_layout">
      <Template num={num} />
    </div>
  );
};

export default StepB;
